import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteSlider, fetchSliderList } from "../actions/slider";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";

const SliderList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { sliderList } = useSelector((state) => state.sliderReducer);

  //breadcrumb
  const translateModule = "slider";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchSliderList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id) return null;
    return (
      <ButtonColumn
        editLink={`/slider-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.title || params.data.id}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(deleteSlider(pageId));
  };

  const columnDefs = [
    {
      headerName: "Naslov",
      field: "title",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: "JWPlayer video",
      field: "videoTargetId",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Stranica",
      field: "sectionType",
      filter: "agTextColumnFilter",
      valueGetter: (params) => {
        const map = {
          HOME: "Početna stranica",
          MASTER: "Masterkat landing stranica",
          MINI: "Minikat landing stranica",
          MICRO: "Mikrokat landing stranica",
        };
        return map[params.data?.sectionType] || params.data?.sectionType || "";
      },
    },

    {
      headerName: "Redni br.",
      field: "position",
      filter: "agTextColumnFilter",
      maxWidth: 180,
    },
    {
      headerName: "Aktivan",
      field: "active",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      maxWidth: 180,
      valueGetter: (params) => {
        if (params.data?.active === true) return "Aktivan";
        if (params.data?.active === false) return "Neaktivan";
        return "";
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchSliderList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={sliderList}
        columnDefs={columnDefs}
        buttonLink={`/slider-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="slider-list"
      />
    </Fragment>
  );
};

export default SliderList;
